import React, { useEffect, useRef } from "react";

const DaumPostcode = ({
  text = "주소 검색",
  address,
  extraAddress,
  onAddressChange
}) => {
  const layerRef = useRef(null);
  const addressRef = useRef(null);
  const extraRef = useRef(null);


  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
    script.async = true;
    document.body.appendChild(script);
    return () => document.body.removeChild(script);
  }, []);

  const closePostcode = () => {
    if (layerRef.current) layerRef.current.style.display = "none";
  };

  const execDaumPostcode = () => {
    new window.daum.Postcode({
      oncomplete: function (data) {
        let addr = "";
        let extraAddr = "";

        if (data.userSelectedType === "R") addr = data.roadAddress;
        else addr = data.jibunAddress;

        if (data.userSelectedType === "R") {
          if (data.bname && /[동|로|가]$/g.test(data.bname)) extraAddr += data.bname;
          if (data.buildingName && data.apartment === "Y")
            extraAddr += extraAddr ? `, ${data.buildingName}` : data.buildingName;
          if (extraAddr) extraAddr = ` (${extraAddr})`;
        }

        if (addressRef.current) addressRef.current.value = addr;
        if (extraRef.current) extraRef.current.value = extraAddr;
        if (onAddressChange) onAddressChange({ address: addr, extra_address: extraAddr });
        if (layerRef.current) layerRef.current.style.display = "none";
      },
      width: "100%",
      height: "100%",
      maxSuggestItems: 5,
    }).embed(layerRef.current);

    if (layerRef.current) {
      layerRef.current.style.display = "block";
      initLayerPosition();
    }
  };

  const initLayerPosition = () => {
    const element = layerRef.current;
    const isMobile = window.innerWidth <= 480;

    if (isMobile) {
      // 모바일: 전체 화면 사용
      const padding = 16;
      element.style.width = `${window.innerWidth - padding * 2}px`;
      element.style.height = `${window.innerHeight - 100}px`;
      element.style.border = "none";
      element.style.borderRadius = "12px";
      element.style.boxShadow = "0 4px 20px rgba(0,0,0,0.3)";
      element.style.left = `${padding}px`;
      element.style.top = "50px";
    } else {
      // 데스크탑: 기존 크기
      const width = 500, height = 600, borderWidth = 5;
      element.style.width = `${width}px`;
      element.style.height = `${height}px`;
      element.style.border = `${borderWidth}px solid`;
      element.style.left = `${(window.innerWidth - width) / 2 - borderWidth}px`;
      element.style.top = `${(window.innerHeight - height) / 2 - borderWidth}px`;
    }
  };

  return (
    <div className="grid grid-cols-2 gap-4 mt-2">
      {/* <input
        type="text"
        ref={addressRef}
        placeholder="주소"
        className="border rounded px-3 py-2 w-full"
        value={address}
        disabled
      /> */}
      <button className="btn-search" onClick={execDaumPostcode}>
        {text}
      </button>
      {/* <input
        type="text"
        ref={extraRef}
        placeholder="참고주소"
        className="border rounded px-3 py-2 w-full"
        value={extraAddress}
        disabled
      /> */}
      <div
        ref={layerRef}
        style={{ display: "none", position: "fixed", overflow: "hidden", zIndex: 100 }}
      >
        <img
          src="//t1.daumcdn.net/postcode/resource/images/close.png"
          alt="닫기 버튼"
          onClick={closePostcode}
          style={{ cursor: "pointer", position: "absolute", right: "-3px", top: "-3px", zIndex: 1 }}
        />
      </div>
    </div>
  );
};

export default DaumPostcode;
